// Components
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Badge, Button, HStack, Stack, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Icon, Label, Comment as CommentItem, Show, Form } from "components"
import { API } from "config"

// Config
import { Enums, Moment, Mask } from "config"
import { useState } from "react"

// Screens
import { Comment } from "screens"

export default function Details({ order, ...props }){

    const toast = useToast()
    const comment = useDisclosure()
    const shipping_type = Enums.OrderShippingType.data(order.data?.shipping_type)
    const [ loading, setLoading ] = useState(false)
    const [ admin_comments, setAdminComments ] = useState(order.data?.admin_comments)

    const handleChangeComments = async () => {
        setLoading('admin_comments')

        try{
            await API.post(`/orders/${order.data?.id}`, { admin_comments, _method: 'put' })
            toast({ title: 'Observações do pedido atualizadas!' })
            order.refetch()
        }catch(err){
            toast({ title: 'Não foi possível atualizar as observações do pedido. Tente novamente.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }
    
    return(
    <>
    <Stack spacing={8}>

        {/* <Alert status="warning" children="Este pedido será cancelado em 15 minutos caso o cliente não anexe o comprovante." /> */}

        <HStack spacing={8}>
            <Label label="Total do pedido:" children={`R$ ${Mask.price(order.data?.total_amount)}`} fontWeight="bold" fontSize="lg" />
            <Label label="Modo de entrega:" children={`${shipping_type.emoji} ${shipping_type.label}`} />
            <Label fontSize="sm" label="Pedido realizado em:" children={Moment(order.data?.requested_at).format('LLL')} />
        </HStack>

        <Show visible={order.data?.status === Enums.OrderStatus.CANCELED}>
            <HStack spacing={8}>
                <Label label="Cancelado em" children={Moment(order.data?.canceled_at).calendar()} />
                <Label label="Motivo do cancelamento" children={order.data?.canceled_reason} />
            </HStack>
        </Show>

        <Accordion allowToggle>
            <AccordionItem>
                <AccordionButton fontSize="sm">
                    {order.data?.comments?.length >= 1 && <Badge colorScheme="orange" children={order.data?.comments?.length} mr={2} />} Comentários deste pedido
                    <AccordionIcon />
                </AccordionButton>
                <AccordionPanel>
                    { order.data?.comments?.map(item => <CommentItem key={item.id} data={item} />) }
                    <Button w="100%" size="sm" children="Adicionar comentário" leftIcon={<Icon name="comment" />} onClick={comment.onOpen} mt={4} />
                    <Alert children="Os comentários deste pedido é visualizado apenas pela equipe interna da empresa e não é exibido para consultores e núcleos." mt={4} />
                </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
                <AccordionButton fontSize="sm">
                    Observações para o cliente
                    <AccordionIcon />
                </AccordionButton>
                <AccordionPanel>
                    <Form.Textarea defaultValue={order.data?.admin_comments} disabled={order.isFetching || !!loading} value={admin_comments} onChange={e => setAdminComments(e.target.value)} label="Insira as observações:" helper="Os comentários deste campo aparecerão para o cliente." />
                    <Button w="100%" mt={2} disabled={order.isFetching || !!loading} isLoading={loading==='admin_comments'} onClick={handleChangeComments}>Atualizar observações</Button>
                </AccordionPanel>
            </AccordionItem>
        </Accordion>        

    </Stack>
    
    {/* Screens */}
    <Comment.Publish {...comment} data={order.data} model="orders" onSuccess={order.refetch} />
    </>
    )
}
